import {
  FallBackImage,
  isEmptyStr,
  KissanEventType,
  normalizeTextContent,
  truncateName,
  useProfileStore,
} from '@ninjacart/nc-nk-store';
import {
  Avatar,
  Content,
  ExpertBadge,
  Paragraph,
  Text,
  useTimeAgo,
  XStack,
  YStack,
} from '@ninjacart/nc-nk-ui';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IQnAReplyItem } from '@ninjacart/nc-nk-core';
import {
  addEventParam,
  INinjaEvent,
  useQueuedEventStore,
} from '@ninjacart/nc-events-sdk-v2';

export function ExpertAnswerCommentCard({
  expert,
  pageName,
  pageExpertName,
  index
}: {
  expert: IQnAReplyItem;
  pageName?: string;
  pageExpertName?: string;
  index?: number|string;
}) {
  const [feedBackBottomSheet, setfFeedBackBottomSheet] = useState<boolean>(false);
  const [showFullContent, setShowFullContent] = useState(false);
  const { t } = useTranslation();
  const userProfile = useProfileStore((state) => state.userProfile);
  const toggleExpansion = () => {
    setShowFullContent(!showFullContent);
  };
  const enqueue = useRef(useQueuedEventStore((state) => state.enqueue)).current;

  const onOpenQnaFeedbackbottomSheet = () => {
    setfFeedBackBottomSheet(true);
  };

  const handleReadMoreClickEvent = () => {
    const qnaReadMoreClickEvent: INinjaEvent = {
      name: KissanEventType.QNA_READ_MORE_CLICK,
      screenDetails: { screen: 'qna page' },
      eventParams: [addEventParam('questionId', expert?.id)],
    };
    enqueue(qnaReadMoreClickEvent);
  };

  const handleReadLessClickEvent = () => {
    const qnaReadLessClickEvent: INinjaEvent = {
      name: KissanEventType.QNA_READ_LESS_CLICK,
      screenDetails: { screen: 'qna page' },
      eventParams: [addEventParam('questionId', expert?.id)],
    };
    enqueue(qnaReadLessClickEvent);
  };

  const [showFullText, setShowFullText] = useState(
    pageName == 'Qna Detail Page' || pageExpertName == 'Qna Detail Page' ? true : false
  );

  const showFullTextFunction = (e: any) => {
    e.stopPropagation(); // to prevent the parent click event
    setShowFullText(!showFullText);
    if (showFullText) {
      handleReadLessClickEvent();
    } else {
      handleReadMoreClickEvent();
    }
  };

  const avatarUriLoad = (reply) => {
    if (reply?.expertPicture && reply?.expertPicture != 'google.com')
      return !isEmptyStr(reply?.expertPicture) ? reply?.expertPicture : FallBackImage;
    else return FallBackImage;
  };

  const handleAnswerViewedEvent = () => {
    const qnaAnswerViewedEvent: INinjaEvent = {
      name: KissanEventType.QNA_ANSWER_VIEWED_MORETHAN_FIVE_SECOND,
      screenDetails: { screen: 'qna page' },
      eventParams: [addEventParam('questionId', expert?.id)],
    };
    enqueue(qnaAnswerViewedEvent);
  };

  useEffect(() => {
    if (pageExpertName === 'Qna Detail Page') {
      const intervalId = setInterval(() => {
        handleAnswerViewedEvent();
      }, 5000);

      return () => clearInterval(intervalId);
    }
  }, [pageExpertName]);

  return (
    <YStack>
      <YStack>
        <XStack marginTop={20} flex={1} alignItems="center">
          <YStack
            padding={10}
            borderRadius={10}
            flex={1}
            paddingBottom={10}
            borderWidth={1}
            backgroundColor={'$expectAnswerCardBg'}
            borderColor={'#CAE9DD'}
          >
            <XStack flexDirection="row" justifyContent="space-between" alignItems="center">
              <XStack flexDirection="row" alignItems="center">
                <Avatar circular size="$3" marginRight={5}>
                  <Avatar.Image
                    accessibilityLabel="Nate Wienert"
                    source={{
                      uri: avatarUriLoad(expert),
                    }}
                  />
                  <Avatar.Fallback delayMs={600} />
                </Avatar>
                <YStack paddingHorizontal={6}>
                  <Content
                    fontSize={16}
                    color={'$expertNameColor'}
                    marginBottom={1}
                    fontWeight={'600'}
                    paddingBottom={0}
                  >
                    {expert?.expertName && expert?.expertName?.length > 0
                      ? truncateName(expert?.expertName, 25)
                      : truncateName(expert?.author?.name, 25)}
                  </Content>
                  {expert?.timestamp && (
                    <Content fontSize={11} fontWeight={'500'} color={'$expertNameColor'}>
                      {useTimeAgo(expert?.timestamp)}
                    </Content>
                  )}
                </YStack>
                <ExpertBadge color={'#fff'} fontSize={12} name={t('page.expert')} />
              </XStack>
            </XStack>

            <Paragraph
              color={'$expertNameColor'}
              style={{
                fontSize: 14,
                fontWeight: '500',
                marginTop: 8,
                paddingLeft: 6,
              }}
            >
              {showFullText ? expert.body : normalizeTextContent(expert?.body, false)}
              {expert?.body?.length > 100 && (
                // <Pressable onPress={showFullTextFunction}>
                <Text
                  onPress={showFullTextFunction}
                  color="$primary"
                  fontSize={14}
                  fontWeight="500"
                  marginTop={8}
                  paddingLeft={3}
                  testID={`kisan_tId_expert_read_more_less_btn_${index}`}
                >
                  {showFullText ? t('page.readLess') : `...${t('page.readMore')}`}
                </Text>
                //  </Pressable>
              )}
            </Paragraph>
          </YStack>
        </XStack>
      </YStack>
    </YStack>
  );
}
